const getTaskButtonColor = (difficulty) => {
    switch (difficulty) {
        case 'easy':
            return 'rgb(39, 174, 96)';  // Vert émeraude
        case 'medium':
            return 'rgb(230, 126, 34)';  // Orange brûlé
        case 'hard':
            return 'rgb(231, 76, 60)';   // Rouge corail
        default:
            return 'rgb(52, 152, 219)';  // Bleu océan par défaut
    }
};

export default getTaskButtonColor;